export default "__VITE_ASSET__D5bc8cZO__"